export default
  `bonusReturnAmount
  bonusStake
  cancelledAt
  cashouts {
    exhaustedPotentialReturnAmount
    uuid
  }
  channel
  comment
  country
  completedAt
  createdAt
  currency
  exchangeRate
  exhaustedPotentialReturnAmount
  id
  isCashoutBet
  isLay
  isMultiple
  isRegraded
  potentialReturnAmount
  regradedByAdmin
  regradedByAdminEmail
  regradedByAdminId
  result
  returnAmount
  selections {
    adjustedPlacedOdds
    closingPrice
    competitionEnName
    competitionIntegrity
    event {
      competition {
        key
        name
      }
      competitors {
        key
        name
      }
      name
      players {
        key
        name
        position {
          key
          name
        }
        team
      }
      startsAt
    }
    eventEnName
    eventId
    externalProvider
    id
    isLive
    marketEnName
    marketId
    marketKey
    metadata
    name
    odds
    outright {
      competition {
        key
        name
      }
      finishesAt
      name
      players {
        key
        name
        position {
          key
          name
        }
        team
      }
    }
    selectionEnName
    specialBetValue
    sportEnName
    sportKey
    updatedAt
  }
  stake
  state
  transitions {
    mayCancel
    mayConfirm
  }
  uuid`;

export interface SportsBetSelection {
  adjustedPlacedOdds?: number;
  closingPrice: number;
  competitionEnName: string;
  competitionIntegrity: number;
  event: {
    competition: {
      key: string;
      name: string;
    }
    competitors: Array<{
      key: string;
      name: string;
    }>,
    name: string;
    players: Array<{
      key: string;
      name: string;
      position: {
        key: string;
        name: string;
      }
      team: string;
    }>,
    startsAt: number;
  };
  eventEnName: string;
  eventId: number;
  externalProvider: string;
  id: number;
  isLive: boolean;
  marketEnName: string;
  marketId: number;
  marketKey: string;
  metadata: string;
  name: string;
  odds: number;
  outright: {
    competition: {
      key: string;
      name: string;
    };
    finishesAt: number;
    name: string;
    players: Array<{
      key: string;
      name: string;
      position: {
        key: string;
        name: string;
      };
      team: string;
    }>
  };
  selectionEnName: string;
  specialBetValue: string;
  sportEnName: string;
  sportKey: string;
  updatedAt: number;
}

interface CashoutRef {
  exhaustedPotentialReturnAmount: number;
  uuid: string;
}

interface MatchedBetRef {
  uuid: string;
}


export interface SportsBet {
  _isPrevBetMultiple: any;
  bonusReturnAmount: number;
  bonusStake: number;
  cancelledAt: number;
  cashouts: CashoutRef[];
  channel: string;
  comment: string;
  country: string;
  completedAt: number;
  createdAt: number;
  currency: string;
  exchangeRate: number;
  exhaustedPotentialReturnAmount: number;
  id: number;
  isCashoutBet: boolean;
  isLay: boolean;
  isMultiple: boolean;
  isRegraded?: boolean;
  matchedBets: MatchedBetRef[];
  potentialReturnAmount: number;
  regradedByAdmin?: boolean;
  regradedByAdminEmail?: string;
  regradedByAdminId?: string;
  result?: string;
  returnAmount: number;
  selections: SportsBetSelection[];
  stake: number;
  state: string;
  transitions: {
    mayCancel: boolean;
    mayConfirm: boolean;
  };
  uuid: string;
}
